/**
 * 백엔드에서 정의한 에러코드 상수값을 관리합니다.
 */

export const LOGIN = {
  FAILED: 2010,
  DUPLICATED: 2011,
  PASSWORD_FAIL_UNDER_5_TIMES: 2027,
  PASSWORD_FAIL_OVER_5_TIMES: 2028,
};

export const CHANGE_PASSWORD = {
  WRONG_CURRENT_PASSWORD: 2012,
  SAME_WITH_CURRENT_PASSWORD: 2013,
  SAME_WITH_PREVIOUS_PASSWORD: 2014,
  SAME_WITH_EMAIL: 2015,
};

export const FIND_ID = {
  WRONG_INPUT: 2016,
  FAILED_TO_SEND_EMAIL: 2017,
};

export const FIND_PASSWORD = {
  WRONG_INPUT: 2018,
  FAILED_TO_SEND_EMAIL: 2017,
};

export const TWO_FACTOR_AUTH = {
  TWO_FACTOR_AUTH_CODE_TIME_EXPIRED: 2023,
  TWO_FACTOR_AUTH_CODE_NOT_MATCHED: 2024,
};

export const ORDERS = {
  INVALID_DELIVERY_DATE_FORMAT: 2003,
  INVALID_PAYMENT_AT_DATE_FORMAT: 2004,
  CHECK_PAYMENT_AT_DATE: 2005,
  INVALID_DATE_RANGE: 2006,
  MINIMUM_REQUIRED_FIELD_MISSING: 2007,
  INVALID_ORDER_CODES: 2008,
};

export const VENDERS = {
  WRONG_PASSWORD: 2019,
  DUPLICATED_MANAGER_NAME_AND_EMAIL: 2021,
};

export const RECEIVE = {
  EXCEL_UPLOAD_INVALID_VENDER: 9000,
  EXCEL_UPLOAD_INVALID_SUPPLIER: 9001,
  EXCEL_UPLOAD_INVALID_CENTER_TEMPERATURE: 9002,
  SKU_AND_QUANTITY_COUNT_EXCEEDED: 9020,
  ROW_COUNT_EXCEEDED: 9104,
  RECEIVE_DATE_TIME_NOT_EXIST: 9030,
  RECEIVE_TIME_DISABLED: 9037,
  RECEIVE_DAILY_CAPA_NOT_FOUND: 9040,
  PICKUP_REGISTER_TIME_EXCEEDED: 9063,
  PICKUP_EDIT_TIME_EXCEEDED: 9056,

  DIFFERENT_WAREHOUSE_INCLUDED: 9065,
  DIFFERENT_SUPPLIER_INCLUDED: 9066,
  DIFFERENT_CENTER_AND_SUPPLIER_INCLUDED: 9067,
};

export const RETURN_DISPOSAL = {
  /**
   * 회수(택배) 신청 송장번호 실패 — 형식 오류·신청 내 중복·개수 초과·다른 이슈카드 중복이 같은 코드를 쓴다.
   * 다른 이슈카드 중복만 `values` 에 문제 송장번호 목록을 담아 내려준다.
   */
  INVOICE_NO_INVALID: 9036,
};

export const PRODUCTS = {
  SKUCODE_NOT_FOUND: 4005,
};

export const CLAIM = {
  ALREADY_RETURN_DELIVERY_ING: 3000,
  ALREADY_PRE_EXCHANGE_DELIVERY_ING: 3002,
  EXCHANGE_RESEND_REQUEST_ERROR: 3004,
  ALREADY_EXCHANGE_RESEND_ING: 3005,
};

export const DELIVERY_AGENCY = {
  /** 백엔드 에러 메세지가 보이는 Dialog 공통 코드 */
  BACKEND_ERROR_DIALOG_CODE: 61000,
  /** 반품 등록 시 회수지가 회수 가능 지역이 아님 — 얼럿으로 노출 */
  COLLECTING_UNSERVICEABLE_AREA_CODE: 60400,
};
